
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axiosInstance";

export const kycApi = createAsyncThunk("kyc", async () => {
  const response = await axiosInstance.get("/kyc");
  return response.data;
});

const kycSlice = createSlice({
  name: "kyc",
  initialState: {
    kyc: [],
    errors: [],
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(kycApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(kycApi.fulfilled, (state, action) => {
        state.kyc = action.payload;
        state.loading = false;
      })
      .addCase(kycApi.rejected, (state, action) => {
        state.errors.push(action.error.message);
        state.loading = false;
      });
  },
});

export default kycSlice.reducer;
